import { Component } from 'preact'
import { Loading } from '.'

export default class AsyncButton extends Component {
  constructor(props) {
    super()

    this.state = { loading: props.loading || false }
    this.handleClick = this.handleClick.bind(this)
    this.handleKewDown = this.handleKewDown.bind(this)
  }

  componentWillReceiveProps(props) {
    let { loading } = props

    if (loading != undefined) {
      this.setState({ loading })
    }
  }

  handleClick(e) {
    let { loading } = this.state
    if (loading) return

    if (this.props.onClick) {
      this.props.onClick(e)
    }
  }

  handleKewDown(e) {
    if (e.key === 'Enter') {
      this.handleClick(e)
    }
  }

  render() {
    let { label, title, loadingSize, disabled } = this.props
    let { loading } = this.state

    return (
      <button
        onClick={this.handleClick}
        title={title}
        disabled={disabled}
        onKeyDown={this.handleKewDown}
        class={Missive.classNames({
          'button': true,
          'button-async': true,
          'button-async--loading': loading,
        })}
      >
        <span>
          <span class="button-async-label">{label}</span>
        </span>
        {loading || this.props.alwaysRenderIcon ? <Loading size={loadingSize} /> : null}
      </button>
    )
  }
}
